"use strict";
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
Object.defineProperty(exports, "__esModule", { value: true });
exports.SecurityType = exports.Scheme = exports.JsonType = exports.EncodingStyle = exports.ParameterLocation = void 0;
exports.hasContent = hasContent;
exports.hasSchema = hasSchema;
exports.hasExample = hasExample;
exports.hasExamples = hasExamples;
exports.isCookieParameter = isCookieParameter;
exports.isHeaderParameter = isHeaderParameter;
exports.isPathParameter = isPathParameter;
exports.isQueryParameter = isQueryParameter;
/**
 * @description The location of the parameter.
 *
 * @see https://github.com/OAI/OpenAPI-Specification/blob/master/versions/3.0.1.md#user-content-parameterIn
 */
var ParameterLocation;
(function (ParameterLocation) {
    ParameterLocation["Query"] = "query";
    ParameterLocation["Header"] = "header";
    ParameterLocation["Cookie"] = "cookie";
    ParameterLocation["Path"] = "path";
})(ParameterLocation || (exports.ParameterLocation = ParameterLocation = {}));
function hasContent(parameter) {
    return parameter.content ? true : false;
}
function hasSchema(parameter) {
    return parameter.schema ? true : false;
}
function hasExample(parameter) {
    return parameter.example ? true : false;
}
function hasExamples(parameter) {
    return parameter.examples ? true : false;
}
function isCookieParameter(parameter) {
    return parameter.in === ParameterLocation.Cookie ? true : false;
}
function isHeaderParameter(parameter) {
    return parameter.in === ParameterLocation.Header ? true : false;
}
function isPathParameter(parameter) {
    return parameter.in === ParameterLocation.Path ? true : false;
}
function isQueryParameter(parameter) {
    return parameter.in === ParameterLocation.Query ? true : false;
}
/**
 * @description common ways of serializing simple parameters
 * @see https://github.com/OAI/OpenAPI-Specification/blob/master/versions/3.0.1.md#style-values
 */
var EncodingStyle;
(function (EncodingStyle) {
    EncodingStyle["Matrix"] = "matrix";
    EncodingStyle["Label"] = "label";
    EncodingStyle["Simple"] = "simple";
    EncodingStyle["Form"] = "form";
    EncodingStyle["SpaceDelimited"] = "spaceDelimited";
    EncodingStyle["PipeDelimited"] = "pipeDelimited";
    EncodingStyle["TabDelimited"] = "tabDelimited";
    EncodingStyle["DeepObject"] = "deepObject";
})(EncodingStyle || (exports.EncodingStyle = EncodingStyle = {}));
var JsonType;
(function (JsonType) {
    JsonType["Array"] = "array";
    JsonType["Boolean"] = "boolean";
    JsonType["Integer"] = "integer";
    JsonType["Number"] = "number";
    JsonType["Object"] = "object";
    JsonType["String"] = "string";
})(JsonType || (exports.JsonType = JsonType = {}));
var Scheme;
(function (Scheme) {
    Scheme["Bearer"] = "bearer";
})(Scheme || (exports.Scheme = Scheme = {}));
var SecurityType;
(function (SecurityType) {
    SecurityType["ApiKey"] = "apiKey";
    SecurityType["Http"] = "http";
    SecurityType["OAuth2"] = "oauth2";
    SecurityType["OpenIDConnect"] = "openIdConnect";
})(SecurityType || (exports.SecurityType = SecurityType = {}));
//# sourceMappingURL=oai3.js.map